import { Plus, Trash2, ShieldAlert } from "lucide-react";
import { TextField, AreaField, Card } from "../Field";
import { DateField } from "../DateField";

export default function SigurnostTab({ record, update }) {
  const list = record.dogadjaji;

  const setItem = (i, key, val) => update({ dogadjaji: list.map((d, idx) => (idx === i ? { ...d, [key]: val } : d)) });
  const add = () => update({ dogadjaji: [...list, { datum: record.datum, vrsta: "", opis: "", mjere: "" }] });
  const remove = (i) => update({ dogadjaji: list.filter((_, idx) => idx !== i) });

  return (
    <div className="grid gap-5">
      {list.length === 0 && (
        <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-300 bg-slate-50/60 py-12 text-center" data-testid="sigurnost-empty-state">
          <ShieldAlert className="mb-2 h-8 w-8 text-slate-300" />
          <p className="text-sm font-medium text-slate-500">Nema evidentiranih posebnih sigurnosnih događaja</p>
          <p className="text-xs text-slate-400">Evakuacije, ozljede, intervencije hitnih službi i slično</p>
        </div>
      )}
      {list.map((d, i) => (
        <Card key={i} title={`Događaj ${i + 1}`} badge="Sigurnosni događaj">
          <div className="grid gap-4 sm:grid-cols-2">
            <DateField label="Datum" value={d.datum} onChange={(v) => setItem(i, "datum", v)} testId={`dogadjaj-${i}-datum`} />
            <TextField label="Vrsta događaja" value={d.vrsta} onChange={(v) => setItem(i, "vrsta", v)} testId={`dogadjaj-${i}-vrsta`} placeholder="npr. ozljeda učenika, evakuacija, dojava" />
          </div>
          <AreaField label="Opis događaja" value={d.opis} onChange={(v) => setItem(i, "opis", v)} testId={`dogadjaj-${i}-opis`} rows={3} />
          <AreaField label="Poduzete mjere" value={d.mjere} onChange={(v) => setItem(i, "mjere", v)} testId={`dogadjaj-${i}-mjere`} rows={3} placeholder="npr. obaviještena hitna služba, ravnatelj, roditelji" />
          <button
            data-testid={`dogadjaj-${i}-obrisi-btn`}
            onClick={() => remove(i)}
            className="inline-flex items-center gap-2 rounded-xl border border-red-200 bg-red-50 px-3.5 py-2 text-xs font-semibold text-red-600 transition-colors hover:bg-red-100"
          >
            <Trash2 className="h-3.5 w-3.5" /> Obriši događaj
          </button>
        </Card>
      ))}
      <div>
        <button
          data-testid="sigurnost-dodaj-btn"
          onClick={add}
          className="inline-flex items-center gap-2 rounded-xl bg-sky-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-sky-700 active:scale-[0.98]"
        >
          <Plus className="h-4 w-4" /> Dodaj sigurnosni događaj
        </button>
      </div>
    </div>
  );
}
